
export const BASE_STORAGE_KEY = 'hep';

export const STORAGE_NAMESPACES = {
  HP: 'hp',
  HCE: 'hce',
  FOSC: 'fosc',
  DI: 'di',
  CEX: 'cex',
  URO: 'uro',
};

export const ORGANIZATION_TYPES = {
    HCE: 'Health Care Entity',
    FOSC: 'Freestanding Outpatient Surgical Center',
    DI: 'Diagnostic Imaging Facility',
    HP: 'Health Plan',
    TPA: 'Third Party Associate',
    URO: 'Utilization Review Organization',
    CEX: 'Capital Expenditure Retrospective Review Provider',
    ALL: 'All',
  };

export const ORGANIZATION_TYPES_SHORT = {
    HCE: 'HCE',
    FOSC: 'FOSC',
    DI: 'DI',
    HP: 'HP',
    TPA: 'TPA',
    URO: 'URO',
    CEX: 'CEX',
    ALL: 'ALL',
};

export const MODEL_TYPES = {
    RegisterContact: 'RegisterContact',
    Organization: 'Organization',
    Contact: 'Contact',
};

export const APPROVAL_TYPES = {
    NewOrganization: 'New Organization',
    NewContact: 'New Contact / Existing Organization',
};

export const ORGANIZATION_STATUS = {
    Active: 'Active',
    Inactive: 'Inactive',
    Pending: 'Pending Approval',
    Rejected: 'Rejected',
};

export const ATTRIBUTE_TYPES = {
  Document: 'Document Type',
  HceTransaction: 'HCET Transaction Type',
  HceEntity: 'HCET Entity Type',
  HceContactAccess: 'HCET Contact Access',
  HceContactRole: 'HCET Contact Role',
  HceLeadershipRole: 'HCET Leadership Role',
  HceRelationshipRole: 'HCET Relationship Role',
  HceServiceType: 'HCET Service Type',
  HceServiceArea: 'HCET Service Area',
  HceTransactionStatus: 'HCET Transaction Status',
  HceJobCategory: 'HCET Job Category',
  BusinessUnit: 'Business Unit Type',
  Affiliation: 'Affiliation Type',
  ContactRole: 'Contact Role',
  CexSection: 'CERR Section',
  HpSection: 'HP Section',
  FoscSection: 'FOSC Section',
  DiSection: 'DI Section',
  UroSection: 'URO Section',
  ReportStatus: 'Report Status',
  CexProjecType: 'Capital Expenditure Project Type',
  CexProjectSubtype1: 'Capital Expenditure Project Subtype 1',
  CexProjectSubtype2: 'Capital Expenditure Project Subtype 2',
  CexProjectSubtype3: 'Capital Expenditure Project Subtype 3',
  CexPriorCapacityLevel: 'Capital Expenditure Prior Capacity',
  DiEquipmentType: 'DI Equipment Type',
  DiScannerType: 'DI Scanner Type',
  DiLeaseType: 'DI Lease Type',
  DiPhysicianCredential: 'DI Physician Credential',
  AdverseDeterminationReason: 'Adverse Determination Reason',
  AuthorizationRequestCategory: 'Authorization Request Category',
};

export const ROLE_DESCRIPTIONS = {
  Administrator: 'Administrator',
  Preparer: 'Preparer',
  CourtesyContact: 'Courtesy Contact',
  CapitalExpenditureContact: 'Capital Expenditure Contact',
};

export const AFFILIATION_TYPES = {
  Administrative: 'Administrative',
  Contractual: 'Contractual',
};

export const CONTACT_ROLES = {
  Administrator: { name: 'Administrator', sortId: 1 },
  Preparer: { name: 'Preparer', sortId: 2 },
  CourtesyContact: { name: 'Reviewer', sortId: 4 },
  CapitalExpenditureContact: { name: 'Capital Expenditure Contact', sortId: 3 },
};


export const ICONS = {
  InfoCircle: 'pi pi-info-circle',
  EditUser: 'pi pi-user-edit',
  ExclamationTriangle: 'pi pi-exclamation-triangle',
  CheckCircle: 'pi pi-check-circle',
  Edit: 'pi pi-pencil',
  Check: 'pi pi-check',
  Close: 'pi pi-times',
  ErrorCircle: 'pi pi-times-circle',
  View: 'pi pi-external-link',
  User: 'pi pi-user',
  Add: 'pi pi-plus-circle',
  Download: 'pi pi-download',
  Upload: 'pi pi-upload',
  Previous: 'pi pi-chevron-left',
  Next: 'pi pi-chevron-right',
  Trash: 'pi pi-trash',
  Home: 'pi pi-home',
  Attach: 'pi pi-paperclip',
  QuestionCircle: 'pi pi-question-circle',
  Users: 'pi pi-users',
  Search: 'pi pi-search',
  ExcelExport: 'pi pi-file-excel',
  PenToSquare: 'pi pi-pen-to-square',
};

export const INPUT_MASKS = {
  Phone: '(999) 999-9999',
  PostalCode: '99999?-9999',
};

export const HCE_TRANSACTION_STATUSES = {
  Pending: "Pending Submission",
  Submitted: "Ready for Review",
  Reviewed: "Reviewed",
  Cancelled: "Cancelled",
};

export const TOAST_SAVE_LIFE = 5000;

export const TOAST_MESSAGE_SEVERITY = {
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Warning: 'warn',
};

export const REPORT_TYPES = {
  Hp: 'HPFSR',
  Hce: 'HCE',
  Fosc: 'FOSCR',
  Di: 'DIFUR',
  Cex: 'CERRR',
  Uro: 'UROPAR',
};

export const SECTION_STATUSES = {
  Pending: 'Pending',
  InProgress: 'In Progress',
  Complete: 'Complete',
};

export const ALERT_TYPES = {
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Warning: 'warning',
};

export const REPORT_STATUS_GROUPS = {
  ReadyForReview: 'Ready for Review',
  ReviewComplete: 'Review Complete',
  Outstanding: 'Outstanding',
};

export const REPORT_SECTION_STATUSES = {
  Pending: 'Pending',
  InProgress: 'In Progress',
  Complete: 'Complete',
};

export const DOWNLOAD_TEMPLATES = {
  HCE: 'MDH_Transaction_Workbook.xlsx',
  DI_ECONOMIC_INTERESTS: 'EconomicInterestTemplate.xlsx',
};

export const BROKEN_RULE_SEVERITY = {
  Error: 'error',
  Warning: 'warning',
  Missing: 'missing',
  Information: 'info',
};

export const BROKEN_RULE_TYPES = {
  Field: 'field',
  Section: 'section',
  Report: 'report',
};

export const REPORT_STATUSES = {
  Pending: 'Pending Submission',
  ReadyForReview: 'Ready for Review',
  ReviewComplete: 'Review Complete',
  InformationRequired: 'Information Required',
};